// import React, { useState, useEffect, useMemo } from "react";
// import { createPortal } from "react-dom";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   RiFileTextLine,
//   RiSearchLine,
//   RiBuilding2Line,
//   RiUserLine,
//   RiCalendarLine,
//   RiCheckboxCircleLine,
//   RiErrorWarningLine,
//   RiEyeLine,
//   RiDeleteBinLine,
//   RiCloseLine,
//   RiCheckLine,
//   RiInboxLine,
//   RiDownload2Line,
//   RiSplitCellsHorizontal,
//   RiEditLine,
//   RiMapPinLine,
//   RiBankLine,
//   RiPhoneLine,
//   RiGroupLine,
// } from "react-icons/ri";
// import { generateSplitBill } from "../Util/GenerateSplitBill";
// import { generateShortSplitBillPDF } from "../Util/Generateshortsplitbillpdf";
// import { LiaRupeeSignSolid } from "react-icons/lia";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { generateInvoicePDF } from "../Util/GenerateInvoicePDF";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const SHORT_SPLIT_MAX_ROWS = 6;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const fmt = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const fmtDate = (d) =>
//   d
//     ? new Date(d).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       })
//     : "—";

// const ones = [
//   "",
//   "One",
//   "Two",
//   "Three",
//   "Four",
//   "Five",
//   "Six",
//   "Seven",
//   "Eight",
//   "Nine",
//   "Ten",
//   "Eleven",
//   "Twelve",
//   "Thirteen",
//   "Fourteen",
//   "Fifteen",
//   "Sixteen",
//   "Seventeen",
//   "Eighteen",
//   "Nineteen",
// ];
// const tens = [
//   "",
//   "",
//   "Twenty",
//   "Thirty",
//   "Forty",
//   "Fifty",
//   "Sixty",
//   "Seventy",
//   "Eighty",
//   "Ninety",
// ];

// function numToWords(n) {
//   n = Math.round(n);
//   if (n === 0) return "Zero";
//   if (n < 0) return "Minus " + numToWords(-n);
//   if (n < 20) return ones[n];
//   if (n < 100)
//     return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
//   if (n < 1000)
//     return (
//       ones[Math.floor(n / 100)] +
//       " Hundred" +
//       (n % 100 ? " " + numToWords(n % 100) : "")
//     );
//   if (n < 100000)
//     return (
//       numToWords(Math.floor(n / 1000)) +
//       " Thousand" +
//       (n % 1000 ? " " + numToWords(n % 1000) : "")
//     );
//   if (n < 10000000)
//     return (
//       numToWords(Math.floor(n / 100000)) +
//       " Lakh" +
//       (n % 100000 ? " " + numToWords(n % 100000) : "")
//     );
//   return (
//     numToWords(Math.floor(n / 10000000)) +
//     " Crore" +
//     (n % 10000000 ? " " + numToWords(n % 10000000) : "")
//   );
// }

// /* ─────────────────────────── Toast ─────────────────────────── */
// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// /* ────────────────────────── Confirm ────────────────────────── */
// const ConfirmDialog = ({ invoiceNumber, onConfirm, onCancel, loading }) => (
//   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
//     <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
//       <div className="p-6">
//         <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
//           <RiDeleteBinLine className="w-6 h-6 text-red-500" />
//         </div>
//         <h3 className="text-base font-bold text-slate-800 text-center mb-1">
//           Delete Invoice?
//         </h3>
//         <p className="text-sm text-slate-500 text-center">
//           <span className="font-semibold text-slate-700">{invoiceNumber}</span>{" "}
//           will be permanently deleted and the Release Order status will revert
//           to <span className="font-semibold text-amber-600">pending</span>.
//         </p>
//       </div>
//       <div className="flex border-t border-slate-100">
//         <button
//           onClick={onCancel}
//           className="flex-1 py-3 text-sm font-semibold text-slate-500 hover:bg-slate-50 transition"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={onConfirm}
//           disabled={loading}
//           className="flex-1 py-3 text-sm font-bold text-red-600 hover:bg-red-50 transition border-l border-slate-100 flex items-center justify-center gap-2 disabled:opacity-60"
//         >
//           {loading ? <Spinner /> : <RiDeleteBinLine className="w-4 h-4" />}
//           Delete
//         </button>
//       </div>
//     </div>
//   </div>
// );

// /* ────────────────────── SplitBill View Modal ────────────────────── */
// const SplitBillViewModal = ({ inv, onClose, onDownload, downloading }) => {
//   const [splits, setSplits] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchSplits = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const res = await axios.get(
//           `${BASE_URL}/splitsbill/${inv._id}/split-bills`,
//         );
//         setSplits(res.data?.data?.splitBills || []);
//       } catch {
//         setError("Failed to load split bills.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchSplits();
//   }, [inv._id]);

//   const grouped = useMemo(() => {
//     const map = new Map();
//     splits.forEach((s) => {
//       const key = s.branch?._id || s.branchName || "__none__";
//       if (!map.has(key))
//         map.set(key, { branchName: s.branchName || "—", items: [] });
//       map.get(key).items.push(s);
//     });
//     return [...map.values()];
//   }, [splits]);

//   return createPortal(
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden">
//         {/* Modal Header */}
//         <div className="flex items-center justify-between px-6 py-4 border-b border-violet-100 bg-violet-50/40 flex-shrink-0">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-sm">
//               <RiSplitCellsHorizontal className="w-4 h-4" />
//             </div>
//             <div>
//               <h2 className="text-sm font-bold text-violet-800">
//                 Split Bill Details
//               </h2>
//               <p className="text-[11px] text-violet-400 font-mono">
//                 {inv.invoiceNumber}
//               </p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => onDownload(inv)}
//               disabled={downloading || splits.length === 0}
//               className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-violet-600 border-violet-600 text-white hover:bg-violet-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {downloading ? (
//                 <Spinner className="w-3.5 h-3.5" />
//               ) : (
//                 <RiDownload2Line className="w-3.5 h-3.5" />
//               )}
//               {downloading ? "Generating…" : "Download PDF"}
//             </button>
//             <button
//               onClick={onClose}
//               className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 text-slate-400 hover:bg-slate-50 hover:text-slate-600 transition"
//             >
//               <RiCloseLine className="w-4 h-4" />
//             </button>
//           </div>
//         </div>

//         {/* Invoice Summary Strip */}
//         <div className="px-6 py-3 bg-slate-50 border-b border-slate-100 flex-shrink-0">
//           <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
//             {[
//               {
//                 label: "Bill To",
//                 value:
//                   inv.billTo?.company ||
//                   inv.releaseOrder?.client?.bankName ||
//                   "—",
//                 icon: RiBuilding2Line,
//               },
//               {
//                 label: "Date",
//                 value: fmtDate(inv.date || inv.createdAt),
//                 icon: RiCalendarLine,
//               },
//               {
//                 label: "Sub Total",
//                 value: `₹${fmt(inv.subTotal)}`,
//                 icon: LiaRupeeSignSolid,
//               },
//               {
//                 label: "Total Amount",
//                 value: `₹${fmt(inv.totalAmount)}`,
//                 icon: LiaRupeeSignSolid,
//               },
//             ].map(({ label, value, icon: Icon }) => (
//               <div key={label} className="flex items-center gap-2">
//                 <Icon className="w-3.5 h-3.5 text-violet-400 flex-shrink-0" />
//                 <div>
//                   <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">
//                     {label}
//                   </div>
//                   <div className="text-xs font-semibold text-slate-700 truncate max-w-[120px]">
//                     {value}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Modal Body */}
//         <div className="overflow-y-auto flex-1 px-6 py-4">
//           {loading ? (
//             <div className="flex flex-col items-center justify-center py-16 gap-3 text-violet-400">
//               <Spinner className="w-8 h-8" />
//               <span className="text-xs font-medium">Loading split bills…</span>
//             </div>
//           ) : error ? (
//             <div className="flex flex-col items-center justify-center py-16 gap-2 text-red-400">
//               <RiErrorWarningLine className="w-8 h-8" />
//               <span className="text-xs font-medium">{error}</span>
//             </div>
//           ) : splits.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-16 gap-2 text-slate-300">
//               <RiInboxLine className="w-10 h-10" />
//               <span className="text-xs font-medium text-slate-400">
//                 No split bills attached yet.
//               </span>
//             </div>
//           ) : (
//             <div className="space-y-4">
//               {grouped.map((group, gi) => (
//                 <div
//                   key={gi}
//                   className="border border-violet-100 rounded-xl overflow-hidden"
//                 >
//                   <div className="flex items-center gap-2 px-4 py-2.5 bg-violet-50/60 border-b border-violet-100">
//                     <RiMapPinLine className="w-3.5 h-3.5 text-violet-500" />
//                     <span className="text-xs font-bold text-violet-700 uppercase tracking-wide">
//                       {group.branchName}
//                     </span>
//                     <span className="ml-auto text-[10px] text-violet-400 font-mono">
//                       {group.items.length} borrower
//                       {group.items.length !== 1 ? "s" : ""}
//                     </span>
//                   </div>

//                   <table className="w-full text-xs">
//                     <thead>
//                       <tr className="border-b border-violet-50 bg-slate-50/60">
//                         {[
//                           "Borrower",
//                           "Per Acc (₹)",
//                           "Acc",
//                           "Sub Total",
//                           "CGST",
//                           "SGST",
//                           "Total",
//                         ].map((h) => (
//                           <th
//                             key={h}
//                             className="px-3 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-wider whitespace-nowrap"
//                           >
//                             {h}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {group.items.map((s, si) => (
//                         <tr
//                           key={si}
//                           className="border-b border-slate-50 last:border-0 hover:bg-violet-50/20 transition"
//                         >
//                           <td className="px-3 py-2.5">
//                             <div className="flex items-center gap-1.5">
//                               <RiUserLine className="w-3 h-3 text-violet-300 flex-shrink-0" />
//                               <span className="font-semibold text-slate-700">
//                                 {s.borrowersName || "—"}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="px-3 py-2.5 font-mono text-slate-600">
//                             {fmt(s.perAcc)}
//                           </td>
//                           <td className="px-3 py-2.5 font-mono text-slate-600">
//                             {s.acc ?? 1}
//                           </td>
//                           <td className="px-3 py-2.5 font-mono text-slate-600">
//                             ₹{fmt(s.subTotal)}
//                           </td>
//                           <td className="px-3 py-2.5 font-mono text-slate-500">
//                             ₹{fmt(s.cgst)}
//                           </td>
//                           <td className="px-3 py-2.5 font-mono text-slate-500">
//                             ₹{fmt(s.sgst)}
//                           </td>
//                           <td className="px-3 py-2.5 font-mono font-bold text-violet-700">
//                             ₹{fmt(s.total)}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                     <tfoot>
//                       <tr className="bg-violet-50/40 border-t border-violet-100">
//                         <td
//                           colSpan={3}
//                           className="px-3 py-2 text-[10px] font-bold text-violet-600 uppercase tracking-widest"
//                         >
//                           Branch Total
//                         </td>
//                         <td className="px-3 py-2 font-bold font-mono text-slate-700 text-xs">
//                           ₹
//                           {fmt(
//                             group.items.reduce(
//                               (s, i) => s + (i.subTotal || 0),
//                               0,
//                             ),
//                           )}
//                         </td>
//                         <td className="px-3 py-2 font-bold font-mono text-slate-600 text-xs">
//                           ₹
//                           {fmt(
//                             group.items.reduce((s, i) => s + (i.cgst || 0), 0),
//                           )}
//                         </td>
//                         <td className="px-3 py-2 font-bold font-mono text-slate-600 text-xs">
//                           ₹
//                           {fmt(
//                             group.items.reduce((s, i) => s + (i.sgst || 0), 0),
//                           )}
//                         </td>
//                         <td className="px-3 py-2 font-extrabold font-mono text-violet-700 text-xs">
//                           ₹
//                           {fmt(
//                             group.items.reduce((s, i) => s + (i.total || 0), 0),
//                           )}
//                         </td>
//                       </tr>
//                     </tfoot>
//                   </table>

//                   {group.items[0]?.selectedBank && (
//                     <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-100 flex flex-wrap gap-4">
//                       <div className="flex items-center gap-1.5 text-[10px] text-slate-500">
//                         <RiBankLine className="w-3 h-3 text-violet-400" />
//                         <span className="font-semibold text-slate-600">
//                           {group.items[0].selectedBank.branchName}
//                         </span>
//                         <span className="text-slate-400">·</span>
//                         <span>{group.items[0].selectedBank.accountNumber}</span>
//                         <span className="text-slate-400">·</span>
//                         <span>{group.items[0].selectedBank.ifscCode}</span>
//                       </div>
//                       {group.items[0]?.selectedQuery?.contactPersonName && (
//                         <div className="flex items-center gap-1.5 text-[10px] text-slate-500">
//                           <RiPhoneLine className="w-3 h-3 text-violet-400" />
//                           <span>
//                             {group.items[0].selectedQuery.contactPersonName}
//                           </span>
//                           <span className="text-slate-400">·</span>
//                           <span>{group.items[0].selectedQuery.phone}</span>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}

//               <div className="flex items-center justify-between px-4 py-3 bg-violet-600 rounded-xl text-white mt-2">
//                 <div className="flex items-center gap-2">
//                   <RiGroupLine className="w-4 h-4 text-violet-200" />
//                   <span className="text-xs font-bold tracking-wide">
//                     Grand Total · {splits.length} split
//                     {splits.length !== 1 ? "s" : ""}
//                   </span>
//                 </div>
//                 <span className="font-extrabold font-mono text-sm">
//                   ₹{fmt(splits.reduce((s, i) => s + (i.total || 0), 0))}
//                 </span>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );
// };

// /* ────────────────────────── Stat Card ────────────────────────── */
// const StatCard = ({ label, value, icon: Icon, accent }) => (
//   <div
//     className={`bg-white border rounded-2xl px-5 py-4 flex items-center gap-4 shadow-sm ${accent}`}
//   >
//     <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 bg-violet-100">
//       <Icon className="w-5 h-5 text-violet-600" />
//     </div>
//     <div>
//       <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//         {label}
//       </div>
//       <div className="text-lg font-extrabold text-slate-800">{value}</div>
//     </div>
//   </div>
// );

// /* ══════════════════════════ AllInvoice ══════════════════════════ */
// const AllInvoice = () => {
//   const navigate = useNavigate();
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [deleting, setDeleting] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [company, setCompany] = useState({});
//   const [pdfLoadingId, setPdfLoadingId] = useState(null);
//   const [splitPdfLoadingId, setSplitPdfLoadingId] = useState(null);
//   const [viewSplitInv, setViewSplitInv] = useState(null);

//   const notify = (message, type = "success") => setToast({ message, type });

//   /* ── Fetch invoices + company ── */
//   const fetchInvoices = async () => {
//     setLoading(true);
//     try {
//       const [invRes, companyRes] = await Promise.allSettled([
//         axios.get(`${BASE_URL}/invoice/all`),
//         axios.get(`${BASE_URL}/company/get`),
//       ]);
//       if (invRes.status === "fulfilled") {
//         setInvoices(invRes.value?.data?.data || []);
//       } else {
//         notify("Failed to load invoices", "error");
//       }
//       if (companyRes.status === "fulfilled") {
//         setCompany(
//           companyRes.value?.data?.data || companyRes.value?.data || {},
//         );
//       }
//     } catch {
//       notify("Failed to load data", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchInvoices();
//   }, []);

//   /* ── Delete invoice ── */
//   const handleDelete = async () => {
//     if (!deleteTarget) return;
//     setDeleting(true);
//     try {
//       await axios.delete(`${BASE_URL}/invoice/${deleteTarget.id}`);
//       notify("Invoice deleted successfully");
//       setInvoices((prev) => prev.filter((inv) => inv._id !== deleteTarget.id));
//       setDeleteTarget(null);
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to delete invoice",
//         "error",
//       );
//     } finally {
//       setDeleting(false);
//     }
//   };

//   /* ── Download invoice PDF ── */
//   const handleDownloadPDF = async (inv) => {
//     setPdfLoadingId(inv._id);
//     try {
//       let fullInv = inv;
//       if (!inv.items || inv.items.length === 0) {
//         const res = await axios.get(`${BASE_URL}/invoice/${inv._id}`);
//         fullInv = res.data?.data || res.data || inv;
//       }
//       const amtWords =
//         numToWords(Math.round(fullInv.totalAmount || 0)) + " Only";
//       const itemOverridesMap = {};
//       if (fullInv.itemEdits && Array.isArray(fullInv.itemEdits)) {
//         fullInv.itemEdits.forEach((edit, idx) => {
//           itemOverridesMap[idx] = edit;
//         });
//       }
//       const invoiceData = {
//         invoiceNumber: fullInv.invoiceNumber || "",
//         date: fullInv.date || fullInv.createdAt || "",
//         pan: fullInv.pan || "",
//         gstNumber: fullInv.gstNumber || "",
//         customerId: fullInv.customerId || "",
//         hsnCode: fullInv.hsnCode,
//         cgstRate: Number(fullInv.cgstRate || 2.5),
//         sgstRate: Number(fullInv.sgstRate || 2.5),
//         cgstAmount: Number(fullInv.cgstAmount || 0),
//         sgstAmount: Number(fullInv.sgstAmount || 0),
//         subTotal: Number(fullInv.subTotal || 0),
//         totalAmount: Number(fullInv.totalAmount || 0),
//         amountInWords: amtWords,
//         billTo: fullInv.billTo || {},
//         items: (fullInv.items || []).map((item, idx) => {
//           const ov = itemOverridesMap[idx] || {};
//           const w = ov.width !== undefined ? ov.width : item.width || 0;
//           const h = ov.height !== undefined ? ov.height : item.height || 0;
//           return {
//             publication: item.publication || "",
//             edition: item.edition || "",
//             hue: item.hue || "B/W",
//             dop: item.dop ? new Date(item.dop).toLocaleDateString("en-IN") : "",
//             page: item.page || item.pagePosition || "",
//             width: w,
//             height: h,
//             volume: w * h,
//             rate:
//               ov.rate !== undefined
//                 ? ov.rate
//                 : item.rate || item.ratePerSqCm || 0,
//             amount: ov.amount !== undefined ? ov.amount : item.amount || 0,
//           };
//         }),
//         company,
//         selectedBank: fullInv.selectedBank || null,
//         selectedQuery: fullInv.selectedQuery || null,
//       };
//       generateInvoicePDF(invoiceData);
//     } catch {
//       notify("Failed to generate PDF", "error");
//     } finally {
//       setPdfLoadingId(null);
//     }
//   };

//   /* ── Navigate to create/edit split bill ── */
//   const handleSplitBill = (inv) => {
//     navigate("/admin/create-splitsbill", {
//       state: {
//         invoiceId: inv._id,
//         invoiceNumber: inv.invoiceNumber,
//         subTotal: inv.subTotal,
//         billTo: inv.billTo,
//         releaseOrder: inv.releaseOrder,
//         selectedBank: inv.selectedBank || null,
//         selectedQuery: inv.selectedQuery || null,
//       },
//     });
//   };

//   /* ── Download split bill PDF ── */
//   const handleDownloadSplitBill = async (inv) => {
//     setSplitPdfLoadingId(inv._id);
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/splitsbill/${inv._id}/split-bills`,
//       );
//       const splits = res.data?.data?.splitBills || [];

//       if (!splits.length) {
//         notify("No split bills found for this invoice", "error");
//         return;
//       }

//       // ── Build groups map — handles both new borrowers[] and legacy flat structure ──
//       const branchMap = new Map();
//       splits.forEach((s) => {
//         const key = s.branch?._id || s.branchName || "__none__";
//         if (!branchMap.has(key))
//           branchMap.set(key, { branchName: s.branchName || "", borrowers: [] });

//         const group = branchMap.get(key);

//         if (s.borrowers && s.borrowers.length > 0) {
//           // New structure: branchWiseSplitBill has a borrowers[] sub-array
//           s.borrowers.forEach((b) => {
//             group.borrowers.push({
//               borrowersName: b.borrowerName || "",
//               perAcc: b.perAccount ?? 0,
//               acc: b.accountNumber ?? 1,
//               subTotal: b.subtotal ?? 0,
//               cgst: b.cgst ?? 0,
//               sgst: b.sgst ?? 0,
//               total: b.total ?? 0,
//             });
//           });
//         } else {
//           // Legacy flat structure fallback
//           group.borrowers.push({
//             borrowersName: Array.isArray(s.borrowersName)
//               ? s.borrowersName.join(", ")
//               : s.borrowersName || "",
//             perAcc: s.perAcc ?? 0,
//             acc: s.acc ?? 1,
//             subTotal: s.subTotal ?? 0,
//             cgst: s.cgst ?? 0,
//             sgst: s.sgst ?? 0,
//             total: s.total ?? 0,
//           });
//         }
//       });

//       const selectedBank = splits[0]?.selectedBank || null;
//       const selectedQuery = splits[0]?.selectedQuery || null;
//       const groups = [...branchMap.values()];

//       const bankName =
//         inv.billTo?.company || inv.releaseOrder?.client?.bankName || "";
//       const adType = inv.releaseOrder?.caption || "Branch Wise Split Bills";

//       // ── splitBillType drives the branch table guard in the PDF util ──
//       const splitBillType =
//         inv.splitBillType || res.data?.data?.splitBillType || "branch";

//       /* ── Routing decision ── */
//       if (splits.length <= SHORT_SPLIT_MAX_ROWS) {
//         // Always fetch the full invoice so we have items, hsnCode, advertisingType
//         let fullInv = inv;
//         if (!inv.items || inv.items.length === 0) {
//           const invRes = await axios.get(`${BASE_URL}/invoice/${inv._id}`);
//           fullInv = invRes.data?.data || invRes.data || inv;
//         }

//         const itemOverridesMap = {};
//         if (fullInv.itemEdits && Array.isArray(fullInv.itemEdits)) {
//           fullInv.itemEdits.forEach((edit, idx) => {
//             itemOverridesMap[idx] = edit;
//           });
//         }

//         const amtWords =
//           numToWords(Math.round(fullInv.totalAmount || 0)) + " Only";

//         // getAllInvoices populates advertisingType as an object { _id, name }
//         const advertisingTypeName =
//           fullInv.advertisingType?.name ||
//           inv.advertisingType?.name ||
//           (typeof fullInv.advertisingType === "string"
//             ? fullInv.advertisingType
//             : "") ||
//           (typeof inv.advertisingType === "string"
//             ? inv.advertisingType
//             : "") ||
//           "";

//         // First item's DOP as the representative publication date
//         const firstDop = fullInv.items?.[0]?.dop || inv.items?.[0]?.dop || "";

//         generateShortSplitBillPDF({
//           invoiceNumber: fullInv.invoiceNumber || "",
//           date: fullInv.date || fullInv.createdAt || "",
//           pan: fullInv.pan || "",
//           gstNumber: fullInv.gstNumber || "",
//           customerId: fullInv.customerId || "",
//           // ── New fields ──────────────────────────────────────────────
//           hsnCode: fullInv.hsnCode || "",
//           advertisingType: advertisingTypeName,
//           dop: firstDop,
//           splitBillType,
//           // ── Existing fields ─────────────────────────────────────────
//           cgstRate: Number(fullInv.cgstRate || 2.5),
//           sgstRate: Number(fullInv.sgstRate || 2.5),
//           cgstAmount: Number(fullInv.cgstAmount || 0),
//           sgstAmount: Number(fullInv.sgstAmount || 0),
//           subTotal: Number(fullInv.subTotal || 0),
//           totalAmount: Number(fullInv.totalAmount || 0),
//           amountInWords: amtWords,
//           billTo: fullInv.billTo || {},
//           items: (fullInv.items || []).map((item, idx) => {
//             const ov = itemOverridesMap[idx] || {};
//             const w = ov.width !== undefined ? ov.width : item.width || 0;
//             const h = ov.height !== undefined ? ov.height : item.height || 0;
//             return {
//               publication: item.publication || "",
//               edition: item.edition || "",
//               hue: item.hue || "B/W",
//               dop: item.dop
//                 ? new Date(item.dop).toLocaleDateString("en-IN")
//                 : "",
//               page: item.page || item.pagePosition || "",
//               width: w,
//               height: h,
//               volume: w * h,
//               rate:
//                 ov.rate !== undefined
//                   ? ov.rate
//                   : item.rate || item.ratePerSqCm || 0,
//               amount: ov.amount !== undefined ? ov.amount : item.amount || 0,
//             };
//           }),
//           selectedBank,
//           selectedQuery,
//           groups,
//           bankName,
//           adType,
//         });

//         notify("Short split bill PDF downloaded");
//       } else {
//         // Large split bill — standalone generator (no changes needed here)
//         generateSplitBill({
//           invoiceNumber: inv.invoiceNumber || "",
//           date: inv.date || inv.createdAt || "",
//           bankName,
//           adType,
//           cgstRate: inv.cgstRate ?? 2.5,
//           sgstRate: inv.sgstRate ?? 2.5,
//           subTotal: inv.subTotal || 0,
//           totalAmount: inv.totalAmount || 0,
//           groups,
//           selectedBank,
//           selectedQuery,
//         });

//         notify("Split bill PDF downloaded");
//       }
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to generate split bill PDF",
//         "error",
//       );
//     } finally {
//       setSplitPdfLoadingId(null);
//     }
//   };

//   /* ── Filter ── */
//   const filtered = useMemo(() => {
//     const q = search.toLowerCase().trim();
//     if (!q) return invoices;
//     return invoices.filter(
//       (inv) =>
//         inv.invoiceNumber?.toLowerCase().includes(q) ||
//         inv.releaseOrder?.roNumber?.toLowerCase().includes(q) ||
//         inv.billTo?.company?.toLowerCase().includes(q) ||
//         inv.billTo?.name?.toLowerCase().includes(q) ||
//         inv.releaseOrder?.client?.bankName?.toLowerCase().includes(q),
//     );
//   }, [invoices, search]);

//   const totalAmount = filtered.reduce((s, i) => s + (i.totalAmount || 0), 0);

//   /* ── Loading state ── */
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-slate-50 flex items-center justify-center">
//         <div className="flex flex-col items-center gap-4 text-blue-400">
//           <Spinner className="w-10 h-10" />
//           <span className="text-sm font-medium">Loading invoices…</span>
//         </div>
//       </div>
//     );
//   }

//   /* ── Render ── */
//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       <header className="bg-white border-b border-violet-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
//               <RiSplitCellsHorizontal className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-violet-800 tracking-tight">
//                 Pending Split Bills
//               </h1>
//               <p className="text-[11px] text-violet-400 tracking-widest uppercase">
//                 Invoices Awaiting Split Bill Processing
//               </p>
//             </div>
//           </div>
//           <div className="relative w-full sm:w-72">
//             <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-violet-300" />
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search invoice, RO, client…"
//               className="w-full pl-9 pr-4 py-2 bg-violet-50/60 border border-violet-200 rounded-xl text-sm text-slate-700 placeholder-violet-300 focus:outline-none focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20 transition"
//             />
//             {search && (
//               <button
//                 onClick={() => setSearch("")}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 text-violet-300 hover:text-violet-500 transition"
//               >
//                 <RiCloseLine className="w-4 h-4" />
//               </button>
//             )}
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 space-y-5 w-full">
//         {/* ── Stat cards ── */}
//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//           <StatCard
//             label="Pending Split Bills"
//             value={invoices.length}
//             icon={RiSplitCellsHorizontal}
//             accent="border-violet-100"
//           />
//           <StatCard
//             label="Total Amount"
//             value={`₹${fmt(invoices.reduce((s, i) => s + (i.totalAmount || 0), 0))}`}
//             icon={LiaRupeeSignSolid}
//             accent="border-emerald-100"
//           />
//           <StatCard
//             label="This Month"
//             value={
//               invoices.filter((i) => {
//                 const d = new Date(i.date || i.createdAt);
//                 const now = new Date();
//                 return (
//                   d.getMonth() === now.getMonth() &&
//                   d.getFullYear() === now.getFullYear()
//                 );
//               }).length
//             }
//             icon={RiCalendarLine}
//             accent="border-blue-100"
//           />
//           <StatCard
//             label="Showing"
//             value={filtered.length}
//             icon={RiCheckboxCircleLine}
//             accent="border-amber-100"
//           />
//         </div>

//         {/* ── Table / Empty state ── */}
//         {filtered.length === 0 ? (
//           <div className="bg-white border border-violet-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
//             <RiInboxLine className="w-12 h-12 text-violet-200" />
//             <p className="text-sm font-semibold text-slate-400">
//               {search
//                 ? "No pending split bills match your search."
//                 : "No pending split bills found."}
//             </p>
//             {search && (
//               <button
//                 onClick={() => setSearch("")}
//                 className="text-xs text-violet-500 hover:underline"
//               >
//                 Clear search
//               </button>
//             )}
//           </div>
//         ) : (
//           <div className="bg-white border border-violet-100 rounded-2xl shadow-sm overflow-hidden">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="border-b border-violet-100 bg-violet-50/40">
//                     {[
//                       "#",
//                       "Invoice No.",
//                       "RO Number",
//                       "Bill To",
//                       "Date",
//                       "Sub Total",
//                       "CGST",
//                       "SGST",
//                       "Total Amount",
//                       "Split",
//                       "Actions",
//                     ].map((h) => (
//                       <th
//                         key={h}
//                         className="px-4 py-3 text-left text-[10px] font-semibold text-violet-500 uppercase tracking-widest whitespace-nowrap"
//                       >
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filtered.map((inv, idx) => (
//                     <tr
//                       key={inv._id}
//                       className="border-b border-violet-50 hover:bg-violet-50/20 transition group"
//                     >
//                       <td className="px-4 py-3 text-xs text-slate-400 font-mono">
//                         {idx + 1}
//                       </td>

//                       <td className="px-4 py-3">
//                         <span className="font-bold text-violet-700 font-mono text-xs">
//                           {inv.invoiceNumber}
//                         </span>
//                       </td>

//                       <td className="px-4 py-3">
//                         <div className="flex items-center gap-1.5">
//                           <RiFileTextLine className="w-3.5 h-3.5 text-violet-300 flex-shrink-0" />
//                           <span className="text-xs font-semibold text-slate-700 font-mono">
//                             {inv.releaseOrder?.roNumber || "—"}
//                           </span>
//                         </div>
//                       </td>

//                       <td className="px-4 py-3">
//                         <div className="flex items-start gap-1.5 min-w-0">
//                           <RiBuilding2Line className="w-3.5 h-3.5 text-violet-300 flex-shrink-0 mt-0.5" />
//                           <div className="min-w-0">
//                             <div className="text-xs font-semibold text-slate-700 truncate max-w-[160px]">
//                               {inv.billTo?.company ||
//                                 inv.releaseOrder?.client?.bankName ||
//                                 "—"}
//                             </div>
//                             {inv.billTo?.name && (
//                               <div className="text-[10px] text-slate-400 flex items-center gap-1">
//                                 <RiUserLine className="w-3 h-3" />
//                                 {inv.billTo.name}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </td>

//                       <td className="px-4 py-3 whitespace-nowrap">
//                         <div className="flex items-center gap-1.5 text-xs text-slate-500">
//                           <RiCalendarLine className="w-3.5 h-3.5 text-violet-300" />
//                           {fmtDate(inv.date || inv.createdAt)}
//                         </div>
//                       </td>

//                       <td className="px-4 py-3 text-xs font-mono text-slate-600 text-left">
//                         ₹{fmt(inv.subTotal)}
//                       </td>

//                       <td className="px-4 py-3 text-xs font-mono text-slate-500 text-left whitespace-nowrap">
//                         ₹{fmt(inv.cgstAmount)}
//                         <span className="text-[10px] text-slate-400">
//                           ({inv.cgstRate}%)
//                         </span>
//                       </td>

//                       <td className="px-4 py-3 text-xs font-mono text-slate-500 text-left whitespace-nowrap">
//                         ₹{fmt(inv.sgstAmount)}
//                         <span className="text-[10px] text-slate-400">
//                           ({inv.sgstRate}%)
//                         </span>
//                       </td>

//                       <td className="px-4 py-3 text-left whitespace-nowrap">
//                         <span className="font-extrabold text-violet-700 font-mono text-sm">
//                           ₹{fmt(inv.totalAmount)}
//                         </span>
//                       </td>

//                       {/* Split column */}
//                       <td className="px-4 py-3">
//                         <div className="flex items-center gap-1.5">
//                           <button
//                             onClick={() => handleSplitBill(inv)}
//                             title={
//                               inv.splitBillStatus === "complete"
//                                 ? "Edit Split Bill"
//                                 : "Create Split Bill"
//                             }
//                             className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-violet-50 border-violet-200 text-violet-700 hover:bg-violet-100 transition whitespace-nowrap"
//                           >
//                             <RiSplitCellsHorizontal className="w-3.5 h-3.5" />
//                             {inv.splitBillStatus === "complete"
//                               ? "Edit Split Bill"
//                               : "Create Split"}
//                           </button>

//                           {inv.splitBillAttached && (
//                             <button
//                               onClick={() => setViewSplitInv(inv)}
//                               title="View Split Bill"
//                               className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition"
//                             >
//                               <RiEyeLine className="w-4 h-4" />
//                             </button>
//                           )}

//                           <button
//                             onClick={() => handleDownloadSplitBill(inv)}
//                             disabled={
//                               splitPdfLoadingId === inv._id ||
//                               !inv.splitBillAttached
//                             }
//                             className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition disabled:opacity-40 disabled:cursor-not-allowed"
//                             title={
//                               inv.splitBillAttached
//                                 ? "Download Split Bill PDF"
//                                 : "No split bills yet"
//                             }
//                           >
//                             {splitPdfLoadingId === inv._id ? (
//                               <Spinner className="w-3.5 h-3.5" />
//                             ) : (
//                               <RiDownload2Line className="w-4 h-4" />
//                             )}
//                           </button>
//                         </div>
//                       </td>

//                       {/* Actions column */}
//                       <td className="px-4 py-3">
//                         <div className="flex items-center gap-2">
//                           <button
//                             onClick={() =>
//                               navigate(`/admin/edit-invoice/${inv._id}`)
//                             }
//                             className="w-8 h-8 flex items-center justify-center rounded-lg border border-amber-200 text-amber-400 hover:text-amber-700 hover:bg-amber-50 hover:border-amber-300 transition"
//                             title="Edit Invoice"
//                           >
//                             <RiEditLine className="w-4 h-4" />
//                           </button>
//                           <button
//                             onClick={() => handleDownloadPDF(inv)}
//                             disabled={pdfLoadingId === inv._id}
//                             className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition disabled:opacity-50"
//                             title="Download Invoice PDF"
//                           >
//                             {pdfLoadingId === inv._id ? (
//                               <Spinner className="w-3.5 h-3.5" />
//                             ) : (
//                               <RiDownload2Line className="w-4 h-4" />
//                             )}
//                           </button>
//                           <button
//                             onClick={() =>
//                               setDeleteTarget({
//                                 id: inv._id,
//                                 invoiceNumber: inv.invoiceNumber,
//                               })
//                             }
//                             className="w-8 h-8 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition"
//                             title="Delete Invoice"
//                           >
//                             <RiDeleteBinLine className="w-4 h-4" />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>

//                 <tfoot>
//                   <tr className="bg-violet-50/60 border-t-2 border-violet-100">
//                     <td
//                       colSpan={5}
//                       className="px-4 py-3 text-xs font-bold text-violet-700 uppercase tracking-widest"
//                     >
//                       Total ({filtered.length} invoice
//                       {filtered.length !== 1 ? "s" : ""})
//                     </td>
//                     <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
//                       ₹
//                       {fmt(filtered.reduce((s, i) => s + (i.subTotal || 0), 0))}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
//                       ₹
//                       {fmt(
//                         filtered.reduce((s, i) => s + (i.cgstAmount || 0), 0),
//                       )}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
//                       ₹
//                       {fmt(
//                         filtered.reduce((s, i) => s + (i.sgstAmount || 0), 0),
//                       )}
//                     </td>
//                     <td className="px-4 py-3 text-left">
//                       <span className="font-extrabold text-violet-800 font-mono text-base">
//                         ₹{fmt(totalAmount)}
//                       </span>
//                     </td>
//                     <td />
//                     <td />
//                   </tr>
//                 </tfoot>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── Modals & Overlays ── */}
//       {deleteTarget && (
//         <ConfirmDialog
//           invoiceNumber={deleteTarget.invoiceNumber}
//           onConfirm={handleDelete}
//           onCancel={() => setDeleteTarget(null)}
//           loading={deleting}
//         />
//       )}

//       {viewSplitInv && (
//         <SplitBillViewModal
//           inv={viewSplitInv}
//           onClose={() => setViewSplitInv(null)}
//           onDownload={handleDownloadSplitBill}
//           downloading={splitPdfLoadingId === viewSplitInv._id}
//         />
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// };

// export default AllInvoice;
import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  RiFileTextLine,
  RiSearchLine,
  RiBuilding2Line,
  RiUserLine,
  RiCalendarLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiEyeLine,
  RiDeleteBinLine,
  RiCloseLine,
  RiCheckLine,
  RiInboxLine,
  RiDownload2Line,
  RiSplitCellsHorizontal,
  RiEditLine,
  RiMapPinLine,
  RiBankLine,
  RiPhoneLine,
  RiGroupLine,
  RiRulerLine,
  RiAddLine,
} from "react-icons/ri";
import { generateSplitBill } from "../Util/GenerateSplitBill";
import { generateShortSplitBillPDF } from "../Util/Generateshortsplitbillpdf";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { generateInvoicePDF } from "../Util/GenerateInvoicePDF";

// ── NEW: Axis Bank invoice PDF ──
import { generateOtherInvoicePDF, isAxisBank } from "../Util/OtherInvoicePDF";

const BASE_URL = process.env.REACT_APP_API_URL;

const SHORT_SPLIT_MAX_ROWS = 10;

const countTotalRows = (splits) =>
  splits.reduce((total, s) => {
    if (s.borrowers && s.borrowers.length > 0)
      return total + s.borrowers.length;
    return total + 1;
  }, 0);

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "—";

const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];
const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function numToWords(n) {
  n = Math.round(n);
  if (n === 0) return "Zero";
  if (n < 0) return "Minus " + numToWords(-n);
  if (n < 20) return ones[n];
  if (n < 100)
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  if (n < 1000)
    return (
      ones[Math.floor(n / 100)] +
      " Hundred" +
      (n % 100 ? " " + numToWords(n % 100) : "")
    );
  if (n < 100000)
    return (
      numToWords(Math.floor(n / 1000)) +
      " Thousand" +
      (n % 1000 ? " " + numToWords(n % 1000) : "")
    );
  if (n < 10000000)
    return (
      numToWords(Math.floor(n / 100000)) +
      " Lakh" +
      (n % 100000 ? " " + numToWords(n % 100000) : "")
    );
  return (
    numToWords(Math.floor(n / 10000000)) +
    " Crore" +
    (n % 10000000 ? " " + numToWords(n % 10000000) : "")
  );
}

/* ─────────────────────────── Toast ─────────────────────────── */
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${type === "success" ? "bg-emerald-50 border border-emerald-200 text-emerald-800" : "bg-red-50 border border-red-200 text-red-800"}`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

/* ────────────────────────── Confirm ────────────────────────── */
const ConfirmDialog = ({ invoiceNumber, onConfirm, onCancel, loading }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
      <div className="p-6">
        <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
          <RiDeleteBinLine className="w-6 h-6 text-red-500" />
        </div>
        <h3 className="text-base font-bold text-slate-800 text-center mb-1">
          Delete Invoice?
        </h3>
        <p className="text-sm text-slate-500 text-center">
          <span className="font-semibold text-slate-700">{invoiceNumber}</span>{" "}
          will be permanently deleted and the Release Order status will revert
          to <span className="font-semibold text-amber-600">pending</span>.
        </p>
      </div>
      <div className="flex border-t border-slate-100">
        <button
          onClick={onCancel}
          className="flex-1 py-3 text-sm font-semibold text-slate-500 hover:bg-slate-50 transition"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className="flex-1 py-3 text-sm font-bold text-red-600 hover:bg-red-50 transition border-l border-slate-100 flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? <Spinner /> : <RiDeleteBinLine className="w-4 h-4" />}{" "}
          Delete
        </button>
      </div>
    </div>
  </div>
);

const SplitBillViewModal = ({ inv, onClose, onDownload, downloading }) => {
  const [splits, setSplits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSplits = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `${BASE_URL}/splitsbill/${inv._id}/split-bills`,
        );
        setSplits(res.data?.data?.splitBills || []);
      } catch {
        setError("Failed to load split bills.");
      } finally {
        setLoading(false);
      }
    };
    fetchSplits();
  }, [inv._id]);

  // ── Build groups handling both new borrowers[] and legacy flat structure ──
  const grouped = useMemo(() => {
    const map = new Map();
    splits.forEach((s) => {
      const key = s.branch?._id || s.branchName || "__none__";
      if (!map.has(key))
        map.set(key, {
          branchName: s.branchName || "—",
          borrowers: [],
          selectedBank: s.selectedBank || null,
          selectedQuery: s.selectedQuery || null,
        });

      const group = map.get(key);

      if (s.borrowers && s.borrowers.length > 0) {
        // New structure
        s.borrowers.forEach((b) => {
          group.borrowers.push({
            borrowersName: b.borrowerName || "—",
            perAcc: b.perAccount ?? 0,
            acc: b.accountNumber ?? 1,
            subTotal: b.subtotal ?? 0,
            cgst: b.cgst ?? 0,
            sgst: b.sgst ?? 0,
            total: b.total ?? 0,
          });
        });
      } else {
        // Legacy flat structure
        group.borrowers.push({
          borrowersName: Array.isArray(s.borrowersName)
            ? s.borrowersName.join(", ")
            : s.borrowersName || "—",
          perAcc: s.perAcc ?? 0,
          acc: s.acc ?? 1,
          subTotal: s.subTotal ?? 0,
          cgst: s.cgst ?? 0,
          sgst: s.sgst ?? 0,
          total: s.total ?? 0,
        });
      }
    });
    return [...map.values()];
  }, [splits]);

  // ── Grand total across all borrowers ──
  const grandTotal = grouped.reduce(
    (acc, group) => {
      group.borrowers.forEach((b) => {
        acc.subTotal += b.subTotal;
        acc.cgst += b.cgst;
        acc.sgst += b.sgst;
        acc.total += b.total;
      });
      return acc;
    },
    { subTotal: 0, cgst: 0, sgst: 0, total: 0 },
  );

  const totalBorrowers = grouped.reduce((s, g) => s + g.borrowers.length, 0);

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-violet-100 bg-violet-50/40 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-sm">
              <RiSplitCellsHorizontal className="w-4 h-4" />
            </div>
            <div>
              <h2 className="text-sm font-bold text-violet-800">
                Split Bill Details
              </h2>
              <p className="text-[11px] text-violet-400 font-mono">
                {inv.invoiceNumber}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => onDownload(inv)}
              disabled={downloading || splits.length === 0}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-violet-600 border-violet-600 text-white hover:bg-violet-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {downloading ? (
                <Spinner className="w-3.5 h-3.5" />
              ) : (
                <RiDownload2Line className="w-3.5 h-3.5" />
              )}
              {downloading ? "Generating…" : "Download PDF"}
            </button>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 text-slate-400 hover:bg-slate-50 hover:text-slate-600 transition"
            >
              <RiCloseLine className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Invoice summary strip */}
        <div className="px-6 py-3 bg-slate-50 border-b border-slate-100 flex-shrink-0">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              {
                label: "Bill To",
                value:
                  inv.billTo?.company ||
                  inv.releaseOrder?.client?.bankName ||
                  "—",
                icon: RiBuilding2Line,
              },
              {
                label: "Date",
                value: fmtDate(inv.date || inv.createdAt),
                icon: RiCalendarLine,
              },
              {
                label: "Sub Total",
                value: `₹${fmt(inv.subTotal)}`,
                icon: LiaRupeeSignSolid,
              },
              {
                label: "Total Amount",
                value: `₹${fmt(inv.totalAmount)}`,
                icon: LiaRupeeSignSolid,
              },
            ].map(({ label, value, icon: Icon }) => (
              <div key={label} className="flex items-center gap-2">
                <Icon className="w-3.5 h-3.5 text-violet-400 flex-shrink-0" />
                <div>
                  <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">
                    {label}
                  </div>
                  <div className="text-xs font-semibold text-slate-700 truncate max-w-[120px]">
                    {value}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Body */}
        <div className="overflow-y-auto flex-1 px-6 py-4">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-16 gap-3 text-violet-400">
              <Spinner className="w-8 h-8" />
              <span className="text-xs font-medium">Loading split bills…</span>
            </div>
          ) : error ? (
            <div className="flex flex-col items-center justify-center py-16 gap-2 text-red-400">
              <RiErrorWarningLine className="w-8 h-8" />
              <span className="text-xs font-medium">{error}</span>
            </div>
          ) : grouped.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 gap-2 text-slate-300">
              <RiInboxLine className="w-10 h-10" />
              <span className="text-xs font-medium text-slate-400">
                No split bills attached yet.
              </span>
            </div>
          ) : (
            <div className="space-y-4">
              {grouped.map((group, gi) => (
                <div
                  key={gi}
                  className="border border-violet-100 rounded-xl overflow-hidden"
                >
                  {/* Branch header */}
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-violet-50/60 border-b border-violet-100">
                    <RiMapPinLine className="w-3.5 h-3.5 text-violet-500" />
                    <span className="text-xs font-bold text-violet-700 uppercase tracking-wide">
                      {group.branchName}
                    </span>
                    <span className="ml-auto text-[10px] text-violet-400 font-mono">
                      {group.borrowers.length} borrower
                      {group.borrowers.length !== 1 ? "s" : ""}
                    </span>
                  </div>

                  {/* Borrowers table */}
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="border-b border-violet-50 bg-slate-50/60">
                        {[
                          "Borrower",
                          "Per Acc (₹)",
                          "Acc",
                          "Sub Total",
                          "CGST",
                          "SGST",
                          "Total",
                        ].map((h) => (
                          <th
                            key={h}
                            className="px-3 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-wider whitespace-nowrap"
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {group.borrowers.map((b, bi) => (
                        <tr
                          key={bi}
                          className="border-b border-slate-50 last:border-0 hover:bg-violet-50/20 transition"
                        >
                          <td className="px-3 py-2.5">
                            <div className="flex items-center gap-1.5">
                              <RiUserLine className="w-3 h-3 text-violet-300 flex-shrink-0" />
                              <span className="font-semibold text-slate-700">
                                {b.borrowersName}
                              </span>
                            </div>
                          </td>
                          <td className="px-3 py-2.5 font-mono text-slate-600">
                            {fmt(b.perAcc)}
                          </td>
                          <td className="px-3 py-2.5 font-mono text-slate-600">
                            {b.acc}
                          </td>
                          <td className="px-3 py-2.5 font-mono text-slate-600">
                            ₹{fmt(b.subTotal)}
                          </td>
                          <td className="px-3 py-2.5 font-mono text-slate-500">
                            ₹{fmt(b.cgst)}
                          </td>
                          <td className="px-3 py-2.5 font-mono text-slate-500">
                            ₹{fmt(b.sgst)}
                          </td>
                          <td className="px-3 py-2.5 font-mono font-bold text-violet-700">
                            ₹{fmt(b.total)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="bg-violet-50/40 border-t border-violet-100">
                        <td
                          colSpan={3}
                          className="px-3 py-2 text-[10px] font-bold text-violet-600 uppercase tracking-widest"
                        >
                          Branch Total
                        </td>
                        <td className="px-3 py-2 font-bold font-mono text-slate-700 text-xs">
                          ₹
                          {fmt(
                            group.borrowers.reduce((s, b) => s + b.subTotal, 0),
                          )}
                        </td>
                        <td className="px-3 py-2 font-bold font-mono text-slate-600 text-xs">
                          ₹
                          {fmt(group.borrowers.reduce((s, b) => s + b.cgst, 0))}
                        </td>
                        <td className="px-3 py-2 font-bold font-mono text-slate-600 text-xs">
                          ₹
                          {fmt(group.borrowers.reduce((s, b) => s + b.sgst, 0))}
                        </td>
                        <td className="px-3 py-2 font-extrabold font-mono text-violet-700 text-xs">
                          ₹
                          {fmt(
                            group.borrowers.reduce((s, b) => s + b.total, 0),
                          )}
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  {/* Bank & contact footer */}
                  {group.selectedBank && (
                    <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-100 flex flex-wrap gap-4">
                      <div className="flex items-center gap-1.5 text-[10px] text-slate-500">
                        <RiBankLine className="w-3 h-3 text-violet-400" />
                        <span className="font-semibold text-slate-600">
                          {group.selectedBank.branchName}
                        </span>
                        <span className="text-slate-400">·</span>
                        <span>{group.selectedBank.accountNumber}</span>
                        <span className="text-slate-400">·</span>
                        <span>{group.selectedBank.ifscCode}</span>
                      </div>
                      {group.selectedQuery?.contactPersonName && (
                        <div className="flex items-center gap-1.5 text-[10px] text-slate-500">
                          <RiPhoneLine className="w-3 h-3 text-violet-400" />
                          <span>{group.selectedQuery.contactPersonName}</span>
                          <span className="text-slate-400">·</span>
                          <span>{group.selectedQuery.phone}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}

              {/* Grand total bar */}
              <div className="flex items-center justify-between px-4 py-3 bg-violet-600 rounded-xl text-white mt-2">
                <div className="flex items-center gap-2">
                  <RiGroupLine className="w-4 h-4 text-violet-200" />
                  <span className="text-xs font-bold tracking-wide">
                    Grand Total · {totalBorrowers} borrower
                    {totalBorrowers !== 1 ? "s" : ""}
                  </span>
                </div>
                <span className="font-extrabold font-mono text-sm">
                  ₹{fmt(grandTotal.total)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

/* ────────────────────────── Stat Card ────────────────────────── */
const StatCard = ({ label, value, icon: Icon, accent }) => (
  <div
    className={`bg-white border rounded-2xl px-5 py-4 flex items-center gap-4 shadow-sm ${accent}`}
  >
    <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 bg-violet-100">
      <Icon className="w-5 h-5 text-violet-600" />
    </div>
    <div>
      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
        {label}
      </div>
      <div className="text-lg font-extrabold text-slate-800">{value}</div>
    </div>
  </div>
);

/* ══════════════════════════ AllInvoice ══════════════════════════ */
const AllInvoice = () => {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [toast, setToast] = useState(null);
  const [company, setCompany] = useState({});
  const [pdfLoadingId, setPdfLoadingId] = useState(null);
  const [splitPdfLoadingId, setSplitPdfLoadingId] = useState(null);
  const [viewSplitInv, setViewSplitInv] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchInvoices = async (page = 1, searchQuery = "") => {
    setLoading(true);

    try {
      const [invRes, companyRes] = await Promise.allSettled([
        axios.get(`${BASE_URL}/invoice/all`, {
          params: {
            page,
            limit: 10,
            searchQuery,
          },
        }),
        axios.get(`${BASE_URL}/company/get`),
      ]);

      if (invRes.status === "fulfilled") {
        const response = invRes.value.data;

        setInvoices(response.data || []);
        setCurrentPage(response.pagination.currentPage || 1);
        setTotalPages(response.pagination.totalPages || 1);
        setTotalRecords(response.pagination.totalRecords || 0);
      } else {
        notify("Failed to load invoices", "error");
      }

      if (companyRes.status === "fulfilled") {
        setCompany(companyRes.value.data.data || companyRes.value.data || {});
      }
    } catch {
      notify("Failed to load data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchInvoices(1, search);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchInvoices(1, "");
  }, []);

  const handleDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await axios.delete(`${BASE_URL}/invoice/${deleteTarget.id}`);
      notify("Invoice deleted successfully");
      setInvoices((prev) => prev.filter((inv) => inv._id !== deleteTarget.id));
      setDeleteTarget(null);
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to delete invoice",
        "error",
      );
    } finally {
      setDeleting(false);
    }
  };

  const handleDownloadPDF = async (inv) => {
    setPdfLoadingId(inv._id);
    try {
      let fullInv = inv;
      if (!inv.items || inv.items.length === 0) {
        const res = await axios.get(`${BASE_URL}/invoice/${inv._id}`);
        fullInv = res.data?.data || res.data || inv;
      }
      const amtWords =
        numToWords(Math.round(fullInv.totalAmount || 0)) + " Only";
      const itemOverridesMap = {};
      if (fullInv.itemEdits && Array.isArray(fullInv.itemEdits))
        fullInv.itemEdits.forEach((edit, idx) => {
          itemOverridesMap[idx] = edit;
        });
      const invoiceData = {
        invoiceNumber: fullInv.invoiceNumber || "",
        date: fullInv.date || fullInv.createdAt || "",
        pan: fullInv.pan || "",
        gstNumber: fullInv.gstNumber || "",
        customerId: fullInv.customerId || "",
        hsnCode: fullInv.hsnCode,
        cgstRate: Number(fullInv.cgstRate || 2.5),
        sgstRate: Number(fullInv.sgstRate || 2.5),
        cgstAmount: Number(fullInv.cgstAmount || 0),
        sgstAmount: Number(fullInv.sgstAmount || 0),
        subTotal: Number(fullInv.subTotal || 0),
        discountAmount: Number(fullInv.discountAmount || 0),
        totalAmount: Number(fullInv.totalAmount || 0),
        amountInWords: amtWords,
        billTo: fullInv.billTo || {},
        remark1: fullInv.remark1 || "",
        remark2: fullInv.remark2 || "",
        remark3: fullInv.remark3 || "",
        splitBillAttached: fullInv.splitBillAttached,
        items: (fullInv.items || []).map((item, idx) => {
          const ov = itemOverridesMap[idx] || {};
          const w = ov.width !== undefined ? ov.width : item.width || 0;
          const h = ov.height !== undefined ? ov.height : item.height || 0;
          return {
            publication: item.publication || "",
            edition: item.edition || "",
            hue: item.hue || "B/W",
            dop: item.dop ? new Date(item.dop).toLocaleDateString("en-IN") : "",
            page: item.page || item.pagePosition || "",
            width: w,
            height: h,
            volume: w * h,
            rate:
              ov.rate !== undefined
                ? ov.rate
                : item.rate || item.ratePerSqCm || 0,
            amount: ov.amount !== undefined ? ov.amount : item.amount || 0,
          };
        }),
        company,
        selectedBank: fullInv.selectedBank || null,
        selectedQuery: fullInv.selectedQuery || null,
        advertisingType:
          fullInv.advertisingType?.name ||
          inv.advertisingType?.name ||
          (typeof fullInv.advertisingType === "string"
            ? fullInv.advertisingType
            : "") ||
          (typeof inv.advertisingType === "string"
            ? inv.advertisingType
            : "") ||
          "",
        axisBankDetails: fullInv.axisBankDetails || null,
      };

      // ── NEW: Route to Axis Bank PDF if billTo is Axis Bank ──
      if (isAxisBank(fullInv.billTo)) {
        generateOtherInvoicePDF(invoiceData);
      } else {
        generateInvoicePDF(invoiceData);
      }
    } catch {
      notify("Failed to generate PDF", "error");
    } finally {
      setPdfLoadingId(null);
    }
  };

  /* ── Branch-wise split bill navigate ── */
  const handleSplitBill = (inv) => {
    navigate("/admin/create-splitsbill", {
      state: {
        invoiceId: inv._id,
        invoiceNumber: inv.invoiceNumber,
        subTotal: inv.subTotal,
        billTo: inv.billTo,
        releaseOrder: inv.releaseOrder,
        selectedBank: inv.selectedBank || null,
        selectedQuery: inv.selectedQuery || null,
      },
    });
  };

  /* ── Size-wise split bill navigate (Step 1) ── */
  const handleSizeWiseSplitBill = (inv) => {
    navigate(`/admin/add-split-sizes/${inv._id}`, {
      state: {
        invoiceId: inv._id,
        invoiceNumber: inv.invoiceNumber,
        subTotal: inv.subTotal,
        billTo: inv.billTo,
        releaseOrder: inv.releaseOrder,
        cgstRate: inv.cgstRate ?? 2.5,
        sgstRate: inv.sgstRate ?? 2.5,
        selectedBank: inv.selectedBank || null,
        selectedQuery: inv.selectedQuery || null,
      },
    });
  };

  /* ── Download branch-wise split bill PDF ── */
  const handleDownloadSplitBill = async (inv) => {
    setSplitPdfLoadingId(inv._id);
    try {
      const res = await axios.get(
        `${BASE_URL}/splitsbill/${inv._id}/split-bills`,
      );
      const splits = res.data?.data?.splitBills || [];
      if (!splits.length) {
        notify("No split bills found for this invoice", "error");
        return;
      }

      const branchMap = new Map();
      splits.forEach((s) => {
        const key = s.branch?._id || s.branchName || "__none__";
        if (!branchMap.has(key))
          branchMap.set(key, { branchName: s.branchName || "", borrowers: [] });
        const group = branchMap.get(key);
        if (s.borrowers && s.borrowers.length > 0) {
          s.borrowers.forEach((b) => {
            group.borrowers.push({
              borrowersName: b.borrowerName || "",
              perAcc: b.perAccount ?? 0,
              acc: b.accountNumber ?? 1,
              subTotal: b.subtotal ?? 0,
              cgst: b.cgst ?? 0,
              sgst: b.sgst ?? 0,
              total: b.total ?? 0,
            });
          });
        } else {
          group.borrowers.push({
            borrowersName: Array.isArray(s.borrowersName)
              ? s.borrowersName.join(", ")
              : s.borrowersName || "",
            perAcc: s.perAcc ?? 0,
            acc: s.acc ?? 1,
            subTotal: s.subTotal ?? 0,
            cgst: s.cgst ?? 0,
            sgst: s.sgst ?? 0,
            total: s.total ?? 0,
          });
        }
      });

      const selectedBank = splits[0]?.selectedBank || null;
      const selectedQuery = splits[0]?.selectedQuery || null;
      const groups = [...branchMap.values()];
      const bankName =
        inv.billTo?.company || inv.releaseOrder?.client?.bankName || "";
      const adType = inv.releaseOrder?.caption || "Branch Wise Split Bills";
      const splitBillType =
        inv.splitBillType || res.data?.data?.splitBillType || "branch";
      const totalBorrowerRows = countTotalRows(splits);

      if (totalBorrowerRows <= SHORT_SPLIT_MAX_ROWS) {
        let fullInv = inv;
        if (!inv.items || inv.items.length === 0) {
          const invRes = await axios.get(`${BASE_URL}/invoice/${inv._id}`);
          fullInv = invRes.data?.data || invRes.data || inv;
        }
        const itemOverridesMap = {};
        if (fullInv.itemEdits && Array.isArray(fullInv.itemEdits))
          fullInv.itemEdits.forEach((edit, idx) => {
            itemOverridesMap[idx] = edit;
          });
        const amtWords =
          numToWords(Math.round(fullInv.totalAmount || 0)) + " Only";
        const advertisingTypeName =
          fullInv.advertisingType?.name ||
          inv.advertisingType?.name ||
          (typeof fullInv.advertisingType === "string"
            ? fullInv.advertisingType
            : "") ||
          (typeof inv.advertisingType === "string"
            ? inv.advertisingType
            : "") ||
          "";
        const firstDop = fullInv.items?.[0]?.dop || inv.items?.[0]?.dop || "";
        generateShortSplitBillPDF({
          invoiceNumber: fullInv.invoiceNumber || "",
          date: fullInv.date || fullInv.createdAt || "",
          pan: fullInv.pan || "",
          gstNumber: fullInv.gstNumber || "",
          customerId: fullInv.customerId || "",
          hsnCode: fullInv.hsnCode || "",
          advertisingType: advertisingTypeName,
          dop: firstDop,
          splitBillType,
          cgstRate: Number(fullInv.cgstRate || 2.5),
          sgstRate: Number(fullInv.sgstRate || 2.5),
          cgstAmount: Number(fullInv.cgstAmount || 0),
          sgstAmount: Number(fullInv.sgstAmount || 0),
          subTotal: Number(fullInv.subTotal || 0),
          totalAmount: Number(fullInv.totalAmount || 0),
          amountInWords: amtWords,
          billTo: fullInv.billTo || {},
          items: (fullInv.items || []).map((item, idx) => {
            const ov = itemOverridesMap[idx] || {};
            const w = ov.width !== undefined ? ov.width : item.width || 0;
            const h = ov.height !== undefined ? ov.height : item.height || 0;
            return {
              publication: item.publication || "",
              edition: item.edition || "",
              hue: item.hue || "B/W",
              dop: item.dop
                ? new Date(item.dop).toLocaleDateString("en-IN")
                : "",
              page: item.page || item.pagePosition || "",
              width: w,
              height: h,
              volume: w * h,
              rate:
                ov.rate !== undefined
                  ? ov.rate
                  : item.rate || item.ratePerSqCm || 0,
              amount: ov.amount !== undefined ? ov.amount : item.amount || 0,
            };
          }),
          selectedBank,
          selectedQuery,
          groups,
          bankName,
          adType,
        });
        notify("Short split bill PDF downloaded");
      } else {
        generateSplitBill({
          invoiceNumber: inv.invoiceNumber || "",
          date: inv.date || inv.createdAt || "",
          bankName,
          adType,
          cgstRate: inv.cgstRate ?? 2.5,
          sgstRate: inv.sgstRate ?? 2.5,
          subTotal: inv.subTotal || 0,
          totalAmount: inv.totalAmount || 0,
          groups,
          selectedBank,
          selectedQuery,
        });
        notify("Split bill PDF downloaded");
      }
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to generate split bill PDF",
        "error",
      );
    } finally {
      setSplitPdfLoadingId(null);
    }
  };

  const filtered = invoices;

  const totalAmount = filtered.reduce((s, i) => s + (i.totalAmount || 0), 0);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-blue-400">
          <Spinner className="w-10 h-10" />
          <span className="text-sm font-medium">Loading invoices…</span>
        </div>
      </div>
    );
  }

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    fetchInvoices(page, search);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <header className="bg-white border-b border-violet-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
              <RiSplitCellsHorizontal className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-violet-800 tracking-tight">
                Pending Split Bills
              </h1>
              <p className="text-[11px] text-violet-400 tracking-widest uppercase">
                Invoices Awaiting Split Bill Processing
              </p>
            </div>
          </div>
          <div className="relative w-full sm:w-72">
            <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-violet-300" />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search invoice, RO, client…"
              className="w-full pl-9 pr-4 py-2 bg-violet-50/60 border border-violet-200 rounded-xl text-sm text-slate-700 placeholder-violet-300 focus:outline-none focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20 transition"
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-violet-300 hover:text-violet-500 transition"
              >
                <RiCloseLine className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </header>

      <div className="px-6 py-6 space-y-5 w-full">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard
            label="Pending Split Bills"
            value={totalRecords}
            icon={RiSplitCellsHorizontal}
            accent="border-violet-100"
          />
          <StatCard
            label="Total Amount"
            value={`₹${fmt(invoices.reduce((s, i) => s + (i.totalAmount || 0), 0))}`}
            icon={LiaRupeeSignSolid}
            accent="border-emerald-100"
          />
          <StatCard
            label="This Month"
            value={
              invoices.filter((i) => {
                const d = new Date(i.date || i.createdAt);
                const now = new Date();
                return (
                  d.getMonth() === now.getMonth() &&
                  d.getFullYear() === now.getFullYear()
                );
              }).length
            }
            icon={RiCalendarLine}
            accent="border-blue-100"
          />
          <StatCard
            label="Showing"
            value={filtered.length}
            icon={RiCheckboxCircleLine}
            accent="border-amber-100"
          />
        </div>

        {filtered.length === 0 ? (
          <div className="bg-white border border-violet-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
            <RiInboxLine className="w-12 h-12 text-violet-200" />
            <p className="text-sm font-semibold text-slate-400">
              {search
                ? "No pending split bills match your search."
                : "No pending split bills found."}
            </p>
            {search && (
              <button
                onClick={() => setSearch("")}
                className="text-xs text-violet-500 hover:underline"
              >
                Clear search
              </button>
            )}
          </div>
        ) : (
          <div className="bg-white border border-violet-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-violet-100 bg-violet-50/40">
                    {[
                      "#",
                      "Invoice No.",
                      "RO Number",
                      "Bill To",
                      "Date",
                      "Sub Total",
                      "CGST",
                      "SGST",
                      "Total Amount",
                      "Branch Split",
                      "Size Split",
                      "Actions",
                    ].map((h) => (
                      <th
                        key={h}
                        className="px-4 py-3 text-left text-[10px] font-semibold text-violet-500 uppercase tracking-widest whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((inv, idx) => (
                    <tr
                      key={inv._id}
                      className="border-b border-violet-50 hover:bg-violet-50/20 transition group"
                    >
                      <td className="px-4 py-3 text-xs text-slate-400 font-mono">
                        {idx + 1}
                      </td>

                      <td className="px-4 py-3">
                        <span className="font-bold text-violet-700 font-mono text-xs">
                          {inv.invoiceNumber}
                        </span>
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1.5">
                          <RiFileTextLine className="w-3.5 h-3.5 text-violet-300 flex-shrink-0" />
                          <span className="text-xs font-semibold text-slate-700 font-mono">
                            {inv.releaseOrder?.roNumber || "—"}
                          </span>
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-start gap-1.5 min-w-0">
                          <RiBuilding2Line className="w-3.5 h-3.5 text-violet-300 flex-shrink-0 mt-0.5" />
                          <div className="min-w-0">
                            <div className="text-xs font-semibold text-slate-700 truncate max-w-[160px]">
                              {inv.billTo?.company ||
                                inv.releaseOrder?.client?.bankName ||
                                "—"}
                            </div>
                            {inv.billTo?.name && (
                              <div className="text-[10px] text-slate-400 flex items-center gap-1">
                                <RiUserLine className="w-3 h-3" />
                                {inv.billTo.name}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>

                      <td className="px-4 py-3 whitespace-nowrap">
                        <div className="flex items-center gap-1.5 text-xs text-slate-500">
                          <RiCalendarLine className="w-3.5 h-3.5 text-violet-300" />
                          {fmtDate(inv.date || inv.createdAt)}
                        </div>
                      </td>

                      <td className="px-4 py-3 text-xs font-mono text-slate-600 text-left">
                        {isAxisBank(inv.billTo) ? (
                          <span title="Axis: Cases × Rate">
                            ₹{fmt(inv.axisBankDetails?.amount || 0)}
                          </span>
                        ) : (
                          `₹${fmt(inv.subTotal)}`
                        )}
                      </td>
                      <td className="px-4 py-3 text-xs font-mono text-slate-500 text-left whitespace-nowrap">
                        {isAxisBank(inv.billTo) ? (
                          <span>
                            ₹{fmt(inv.axisBankDetails?.cgst || 0)}
                            <span className="text-[10px] text-slate-400">
                              (2.5%)
                            </span>
                          </span>
                        ) : (
                          <span>
                            ₹{fmt(inv.cgstAmount)}
                            <span className="text-[10px] text-slate-400">
                              ({inv.cgstRate}%)
                            </span>
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3 text-xs font-mono text-slate-500 text-left whitespace-nowrap">
                        {isAxisBank(inv.billTo) ? (
                          <span>
                            ₹{fmt(inv.axisBankDetails?.sgst || 0)}
                            <span className="text-[10px] text-slate-400">
                              (2.5%)
                            </span>
                          </span>
                        ) : (
                          <span>
                            ₹{fmt(inv.sgstAmount)}
                            <span className="text-[10px] text-slate-400">
                              ({inv.sgstRate}%)
                            </span>
                          </span>
                        )}
                      </td>

                      <td className="px-4 py-3 text-left whitespace-nowrap">
                        <span className="font-extrabold text-violet-700 font-mono text-sm">
                          ₹
                          {fmt(
                            isAxisBank(inv.billTo)
                              ? inv.axisBankDetails?.totalAmount || 0
                              : inv.totalAmount,
                          )}
                        </span>
                      </td>

                      {/* ── Branch-wise split column ── */}
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1.5">
                          <button
                            onClick={() => handleSplitBill(inv)}
                            title={
                              inv.splitBillStatus === "complete"
                                ? "Edit Branch Split Bill"
                                : "Create Branch Split"
                            }
                            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-violet-50 border-violet-200 text-violet-700 hover:bg-violet-100 transition whitespace-nowrap"
                          >
                            <RiSplitCellsHorizontal className="w-3.5 h-3.5" />
                            {inv.splitBillStatus === "complete"
                              ? "Edit"
                              : "Create"}
                          </button>

                          {inv.splitBillAttached && (
                            <button
                              onClick={() => setViewSplitInv(inv)}
                              title="View Split Bill"
                              className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition"
                            >
                              <RiEyeLine className="w-4 h-4" />
                            </button>
                          )}

                          <button
                            onClick={() => handleDownloadSplitBill(inv)}
                            disabled={
                              splitPdfLoadingId === inv._id ||
                              !inv.splitBillAttached
                            }
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition disabled:opacity-40 disabled:cursor-not-allowed"
                            title={
                              inv.splitBillAttached
                                ? "Download Branch Split Bill PDF"
                                : "No split bills yet"
                            }
                          >
                            {splitPdfLoadingId === inv._id ? (
                              <Spinner className="w-3.5 h-3.5" />
                            ) : (
                              <RiDownload2Line className="w-4 h-4" />
                            )}
                          </button>
                        </div>
                      </td>

                      {/* ── Size-wise split column ── */}
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1.5">
                          {(inv.splitBillType === "size" ||
                            inv.splitBillType === "both") &&
                          inv.splitBillAttached ? (
                            // ── Existing size split: show Edit Step 1 + Edit Step 2 ──
                            <>
                              <button
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-split-sizes/${inv._id}`,
                                    {
                                      state: {
                                        invoiceId: inv._id,
                                        invoiceNumber: inv.invoiceNumber,
                                        subTotal: inv.subTotal,
                                        billTo: inv.billTo,
                                        releaseOrder: inv.releaseOrder,
                                        cgstRate: inv.cgstRate ?? 2.5,
                                        sgstRate: inv.sgstRate ?? 2.5,
                                        selectedBank: inv.selectedBank || null,
                                        selectedQuery:
                                          inv.selectedQuery || null,
                                      },
                                    },
                                  )
                                }
                                title="Edit Size Rows (Step 1)"
                                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-indigo-50 border-indigo-200 text-indigo-700 hover:bg-indigo-100 transition whitespace-nowrap"
                              >
                                <RiEditLine className="w-3.5 h-3.5" />
                                Sizes
                              </button>
                              <button
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-size-wise-splitbill/${inv._id}`,
                                    {
                                      state: {
                                        invoiceId: inv._id,
                                        invoiceNumber: inv.invoiceNumber,
                                        billTo: inv.billTo,
                                        releaseOrder: inv.releaseOrder,
                                        cgstRate: inv.cgstRate ?? 2.5,
                                        sgstRate: inv.sgstRate ?? 2.5,
                                        selectedBank: inv.selectedBank || null,
                                        selectedQuery:
                                          inv.selectedQuery || null,
                                      },
                                    },
                                  )
                                }
                                title="Edit Branches (Step 2)"
                                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100 transition whitespace-nowrap"
                              >
                                <RiEditLine className="w-3.5 h-3.5" />
                                Branches
                              </button>
                            </>
                          ) : (
                            // ── No size split yet: show Create (goes to AddSplitSizes Step 1) ──
                            <button
                              onClick={() => handleSizeWiseSplitBill(inv)}
                              title="Add Size Rows (Step 1)"
                              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-indigo-50 border-indigo-200 text-indigo-700 hover:bg-indigo-100 transition whitespace-nowrap"
                            >
                              <RiRulerLine className="w-3.5 h-3.5" />
                              Sizes
                            </button>
                          )}
                        </div>
                      </td>

                      {/* Actions column */}
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() =>
                              navigate(`/admin/edit-invoice/${inv._id}`)
                            }
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-amber-200 text-amber-400 hover:text-amber-700 hover:bg-amber-50 hover:border-amber-300 transition"
                            title="Edit Invoice"
                          >
                            <RiEditLine className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDownloadPDF(inv)}
                            disabled={pdfLoadingId === inv._id}
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-violet-200 text-violet-400 hover:text-violet-700 hover:bg-violet-50 hover:border-violet-300 transition disabled:opacity-50"
                            title={
                              isAxisBank(inv.billTo)
                                ? "Download Axis Bank Invoice PDF"
                                : "Download Invoice PDF"
                            }
                          >
                            {pdfLoadingId === inv._id ? (
                              <Spinner className="w-3.5 h-3.5" />
                            ) : (
                              <RiDownload2Line className="w-4 h-4" />
                            )}
                          </button>
                          {/* ── NEW: Axis Bank badge indicator on the download button ── */}
                          {isAxisBank(inv.billTo) && (
                            <span
                              title="Axis Bank — special invoice format will be used"
                              className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-red-100 text-red-600 border border-red-200 whitespace-nowrap"
                            >
                              AXIS
                            </span>
                          )}
                          <button
                            onClick={() =>
                              setDeleteTarget({
                                id: inv._id,
                                invoiceNumber: inv.invoiceNumber,
                              })
                            }
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition"
                            title="Delete Invoice"
                          >
                            <RiDeleteBinLine className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr className="bg-violet-50/60 border-t-2 border-violet-100">
                    <td
                      colSpan={5}
                      className="px-4 py-3 text-xs font-bold text-violet-700 uppercase tracking-widest"
                    >
                      Total ({filtered.length} invoice
                      {filtered.length !== 1 ? "s" : ""})
                    </td>
                    <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
                      ₹
                      {fmt(filtered.reduce((s, i) => s + (i.subTotal || 0), 0))}
                    </td>
                    <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
                      ₹
                      {fmt(
                        filtered.reduce((s, i) => s + (i.cgstAmount || 0), 0),
                      )}
                    </td>
                    <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700 text-left">
                      ₹
                      {fmt(
                        filtered.reduce((s, i) => s + (i.sgstAmount || 0), 0),
                      )}
                    </td>
                    <td className="px-4 py-3 text-left">
                      <span className="font-extrabold text-violet-800 font-mono text-base">
                        ₹{fmt(totalAmount)}
                      </span>
                    </td>
                    <td />
                    <td />
                    <td />
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}
      </div>

      <div className="flex items-center justify-end gap-2 mt-4">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>

        <span className="px-3 text-sm font-medium text-slate-600">
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>

      {deleteTarget && (
        <ConfirmDialog
          invoiceNumber={deleteTarget.invoiceNumber}
          onConfirm={handleDelete}
          onCancel={() => setDeleteTarget(null)}
          loading={deleting}
        />
      )}
      {viewSplitInv && (
        <SplitBillViewModal
          inv={viewSplitInv}
          onClose={() => setViewSplitInv(null)}
          onDownload={handleDownloadSplitBill}
          downloading={splitPdfLoadingId === viewSplitInv._id}
        />
      )}
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default AllInvoice;
